<template>
    <div>
        <forms
            :settings="settings"
            @onFormButtonClick="onFormButtonClick"
            @onInput="onInput"
        >
        </forms>
    </div>
</template>

<script>
import Forms from "../../../../components/form/Forms";
import axios from "axios";
import toastr from "toastr";
export default {
    name: "SkupTemaForma",
    components: { Forms },
    props:{
        disabled:{
            type: Boolean,
            default: false
        },
        id:{
            default: null
        },
        modal:{
            type: Boolean,
            default: false
        },
        action: {
            type: String
        }
    },
    data(){
        return {
            settings: {},
            errors: {},
            route: '/skupovi/' + this.$route.params.skup_id + '/teme',
            url: 'tema',
            data: {},
            skup_id: this.$route.params.skup_id,
            skup: null,

            podrucja_tema_select: [],
            vrste_tema_select: []
        }
    },

    methods: {

        async fetchSkup(){
            let vm = this
            await axios.get( process.env.VUE_APP_API_URL + 'skup' + '/' + this.skup_id )
                .then( response => vm.skup = response.data )
                .catch( error => console.log( error ) )
        },

        async fetctPodrucjaTema(){
            let vm = this
            const response = await axios.get(process.env.VUE_APP_API_URL + 'podrucje-teme' )
            return response.data.data.map( function( item ) {
                vm.podrucja_tema_select.push(
                    {
                        key: item.id.toString(),
                        value: item.naziv
                    }
                )
            } )
        },

        getPodrucjeTeme(id) {
            return this.podrucja_tema_select.find( item => item.key === id )
        },

        async fetchVrsteTema(){
            let vm = this
            const response = await axios.get(process.env.VUE_APP_API_URL + 'vrsta-teme' )
            return response.data.data.map( function( item ) {
                vm.vrste_tema_select.push(
                    {
                        key: item.id.toString(),
                        value: item.naziv
                    }
                )
            } )
        },

        getVrsaTeme( id ){
            return this.vrste_tema_select.find( item => item.key === id )
        },

        async init(){

            let vm = this

            vm.open_loader = true

            await vm.fetchSkup()
            await vm.fetctPodrucjaTema()
            await vm.fetchVrsteTema()

            if ( vm.action === 'edit' || vm.action === 'show' ){

                axios.get( process.env.VUE_APP_API_URL + vm.url + '/' + vm.id )
                    .then( function ( response ) {
                        vm.data['skup_id'] = response.data.skup_id.toString()
                        vm.data['broj_teme'] = response.data.broj_teme
                        vm.data['naziv'] = response.data.naziv
                        vm.data['datum_i_vrijeme_od'] = response.data.datum_i_vrijeme_od
                        vm.data['datum_i_vrijeme_do'] = response.data.datum_i_vrijeme_do
                        vm.data['podrucje_teme_id'] = response.data.podrucje_teme_id ? response.data.podrucje_teme_id.toString() : ''
                        vm.data['vrsta_teme_id'] = response.data.vrsta_teme_id ? response.data.vrsta_teme_id.toString() : ''
                        vm.data['predavaci'] = response.data.predavaci

                        response.data.teme_sait_vrste_sudionika.forEach( item => {
                            vm.data['sati_' + item.vrsta_sudionika_id ] = item.sati
                            vm.data['sati_regulativa_' + item.vrsta_sudionika_id ] = item.sati_regulativa
                        } )


                        vm.$emit( 'returnData', response.data )
                        vm.setupForm()
                        vm.open_loader = false
                    } )
                    .catch( function ( error ) {
                        vm.open_loader = false
                        if(error instanceof Error) {
                            console.log( 'Error: ' . error);
                        } else {
                            console.log( 'Unexpected response: ' . error);
                        }
                    } )

            } else if ( vm.action === 'create' ) {
                vm.data = {}
                vm.setupForm()
                vm.open_loader = false
            } else {
                vm.open_loader = false
            }
        },

        setupForm(){

            let vm = this;

            vm.buttons = []

            let button_cancel = {
                id: 'cancel',
                title: 'Odustani',
                type: 'warning',
                action: 'redirect', // request
                config: {
                    url: vm.route + ( vm.action === 'edit' ? ( '/' + vm.id) : '' )
                }
            }

            let button_delete = {
                id: 'delete',
                title: 'Obriši',
                type: 'danger',
                action: 'request',
                config: {
                    method: 'DELETE',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let button_edit = {
                id: 'edit',
                title: 'Uredi',
                type: 'success',
                action: 'redirect',
                config: {
                    url: vm.route +  '/' + vm.id +'/edit'
                }
            }

            let button_save = {
                id: 'save',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'POST',
                    url: process.env.VUE_APP_API_URL + vm.url
                }
            }

            let button_update = {
                id: 'update',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'PUT',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let buttons = []


            if( vm.action === 'edit' ){
                buttons.push( button_cancel)
                buttons.push( button_update)
            } else if( vm.action === 'show' ) {
                buttons.push( button_cancel )
                buttons.push( button_delete )
                buttons.push( button_edit )
            }
            else if ( vm.action === 'create' ) {
                buttons.push( button_cancel )
                buttons.push( button_save )
            } else {
                return
            }

            let inputs = []


            let skup_id_input = {
                name: 'skup_id',
                type: 'hidden',
                value: vm.skup_id,
                disabled: vm.disabled,
                config: {
                    hidden:true
                }
            }
            inputs.push( skup_id_input )

            let broj_teme_input = {
                name: 'broj_teme',
                type: 'input',
                title: 'Broj teme',
                value:  vm.data.broj_teme,
                width: 12,
                error: vm.errors['broj_teme'] ? vm.errors['broj_teme'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
            }
            inputs.push( broj_teme_input )

            let naziv_input = {
                name: 'naziv',
                type: 'input',
                title: 'Naziv',
                value:  vm.data.naziv,
                width: 12,
                error: vm.errors['naziv'] ? vm.errors['naziv'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
            }
            inputs.push( naziv_input )

            let datum_i_vrijeme_od_input = {
                name: 'datum_i_vrijeme_od',
                type: 'datepicker',
                title: 'Datum početka',
                value: vm.data.datum_i_vrijeme_od,
                width: 12,
                error: vm.errors['datum_i_vrijeme_od'] ? vm.errors['datum_i_vrijeme_od'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    mode: 'dateTime'
                }
            }
            inputs.push( datum_i_vrijeme_od_input )

            let datum_i_vrijeme_do_input = {
                name: 'datum_i_vrijeme_do',
                type: 'datepicker',
                title: 'Datum završetka',
                value: vm.data.datum_i_vrijeme_do,
                width: 12,
                error: vm.errors['datum_i_vrijeme_do'] ? vm.errors['datum_i_vrijeme_do'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    mode: 'dateTime',
                }
            }
            inputs.push( datum_i_vrijeme_do_input )


            let podrucje_teme_id_input = {
                name: 'podrucje_teme_id',
                type: 'select',
                title: 'Područje teme',
                value: vm.data.podrucje_teme_id ? vm.getPodrucjeTeme( vm.data.podrucje_teme_id ) : '',
                width: 12,
                error: vm.errors['podrucje_teme_id'] ? vm.errors['podrucje_teme_id'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: false,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    options: vm.podrucja_tema_select,
                }
            }
            inputs.push( podrucje_teme_id_input )

            let vrsta_teme_id_input = {
                name: 'vrsta_teme_id',
                type: 'select',
                title: 'Vrsta teme',
                value: vm.data.vrsta_teme_id ? vm.getVrsaTeme( vm.data.vrsta_teme_id ) : '',
                width: 12,
                error: vm.errors['vrsta_teme_id'] ? vm.errors['vrsta_teme_id'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: false,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    options: vm.vrste_tema_select,
                }
            }
            inputs.push( vrsta_teme_id_input )


            let predavaci_input = {
                name: 'predavaci',
                type: 'input',
                title: 'Predavači',
                value:  vm.data.predavaci,
                width: 12,
                error: vm.errors['predavaci'] ? vm.errors['predavaci'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
            }
            inputs.push( predavaci_input )



            let main_section = {
                name: ' ',
                width: 12,
                inputs: inputs
            }

            let sections = []

            sections.push( main_section )

            vm.skup.skupovi_vrste_sudionika.forEach( function( skup_vrsta_sudionika ) {

                let vrsta_sudionika_section = []
                let vrsta_sudionika_inputs = []

                let sati_input = {
                    name: 'sati_' + skup_vrsta_sudionika.vrsta_sudionika.id,
                    type: 'input',
                    title: 'Sati',
                    value:  vm.data['sati_' + skup_vrsta_sudionika.vrsta_sudionika.id ],
                    width: 6,
                    error: vm.errors['sati_' + skup_vrsta_sudionika.vrsta_sudionika.id ] ? vm.errors['sati_' + skup_vrsta_sudionika.vrsta_sudionika.id ] : '',
                    note: '',
                    explanation: '',
                    placeholder: '',
                    required: false,
                    readonly: vm.disabled,
                    disabled: skup_vrsta_sudionika.vrsta_sudionika.id.toString() === '1' ? vm.disabled : true,
                    config: {
                        title_width: 4,
                        input_width: 8
                    }
                }


                let sati_regulativa_input = {
                    name: 'sati_regulativa_' + skup_vrsta_sudionika.vrsta_sudionika.id,
                    type: 'input',
                    title: 'Sati regulativa',
                    value:  vm.data['sati_regulativa_' + skup_vrsta_sudionika.vrsta_sudionika.id ],
                    width: 6,
                    error: vm.errors['sati_regulativa_' + skup_vrsta_sudionika.vrsta_sudionika.id ] ? vm.errors['sati_regulativa_' + skup_vrsta_sudionika.vrsta_sudionika.id ] : '',
                    note: '',
                    explanation: '',
                    placeholder: '',
                    required: false,
                    readonly: vm.disabled,
                    disabled: skup_vrsta_sudionika.vrsta_sudionika.id.toString() === '1' ? vm.disabled : true,
                    config: {
                        title_width: 4,
                        input_width: 8
                    }
                }

                vrsta_sudionika_inputs.push( sati_input )
                vrsta_sudionika_inputs.push( sati_regulativa_input )

                vrsta_sudionika_section = {
                    name: skup_vrsta_sudionika.vrsta_sudionika.naziv,
                    width: 12,
                    inputs: vrsta_sudionika_inputs
                }

                sections.push( vrsta_sudionika_section )

            } );


            let settings = {
                width: 6,
                modal: false,
                tabs:[
                    {
                        name: '',
                        active: true,
                        sections: sections
                    },
                ],
                buttons: buttons
            }

            vm.settings = settings
        },

        /**
         *  on input return data
         */
        onInput( name, value ){
            if( this.data[name] !== value ){
                this.data[name] = value
            }
        },

        /**
         *  on button click
         */
        onFormButtonClick( id, action, config, data  ){

            if( id === 'save' || id === 'update' ){
                if( data.success){
                    if( id == 'save' )
                        toastr.success( 'Uspješno spremljeno!' )
                    else if ( id == 'update' )
                        toastr.success( 'Uspješno ažurirano!' )
                    this.$router.push({ path: this.route + '/' + data.data.id } )
                } else {
                    this.errors = data.messages
                    this.init()
                }
            } else if( id == 'delete' ){
                toastr.error( 'Uspješno obrisano!' )
                this.$router.push({ path: this.route } )
            }

        },
    },

    mounted() {
        this.init()
    }
}
</script>

<style scoped>

</style>
